/* eslint-disable radix */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import MaxLengthNumericEditor from '../../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../../SharedModules/StyleConstant/StyleConstant';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}
const tableHead = [
  {
    headerName: 'Action',
    field: 'index',
    filter: false,
    sortable: false,
    editable: false,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    resizable: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DeleteBoxRender',
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Holiday Date',
    field: 'holidayDt',
    comparator: dateComparator,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer: 'holidayDtDatePicker',
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Holiday Description',
    field: 'holidayDescr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    //sort: ['asc'],
    minWidth: Styles.Width_600,
    cellRenderer: 'TextBoxRender',
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export default tableHead;
